module.exports = __webpack_public_path__ + "img/CAT_LABWARE_EQUIPMENT.7a224ab4.svg";